module.exports = __webpack_public_path__ + "static/img/gzh1.f720fe6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gzh1.jpg
// module id = e3YZ
// module chunks = 1